import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {ContactSearchData} from "./contact-search.data";

@Injectable()
export class ContactSearchModel extends SearchModel<ContactSearchData> {

    constructor(injector: Injector) {
        super(injector, ContactSearchData)
    }

    override getIdentifierField(): string {
        return "id";
    }
}
